import Breadcrumbs from "components/breadcrumbs";
import Gamification from "components/gamification";
import { useSelector } from "react-redux";
import AnimatedPage from "utils/animatedPage";
import AppScreen from "../ScreenWithSidebar";

import { Skeleton } from "antd";
import * as USERS_SERVICES from "api/services/auth/auth.services";
import { separateThenGroup, StatusCode } from "common/enums";
import { useEffect, useState } from "react";
import Ellipse from "../../../assets/images/app/ellipse_wallet_5.svg";
import Lines from "../../../assets/images/app/teachers/join_community_lines.svg";

const StudentGamification: React.FC = () => {

    const { user } = useSelector((state) => state.auth);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [gamificationData, setGamificationData] = useState<any>();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const getGamification = async () => {
        try {
            setIsLoading(true);
            const response = await USERS_SERVICES.getGamification("student");
            if (response?.statusCode === StatusCode.OK) {
                const separated = separateThenGroup(response?.data);
                setGamificationData(separated);
            }
        } catch (error: any) {
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (user) {
            getGamification();
        }
    }, [user]);

    return (
        <AnimatedPage>
            {!isMobile && <Breadcrumbs isGamification />}
            <AppScreen>
                <div style={{ marginTop: isMobile ? "0" : "10vh", marginBottom: "10vh" }}>
                    {!isMobile && <img src={Lines} style={{ position: "absolute", top: "0px", left: "10%", zIndex: "-1" }}></img>}
                    {!isMobile && <img src={Ellipse} height={120} style={{ position: "absolute", top: "40px", right: "10%", zIndex: "-1" }}></img>}
                    {isLoading ? <Skeleton /> : <Gamification data={gamificationData} userType="student" displayedFromOnboarding={false} />}
                </div>
            </AppScreen>
        </AnimatedPage >
    );
}

export default StudentGamification;